#import "./StaffTrainingModuleSummaryFields.graphql"
#import "./StaffTrainingPolicyFields.graphql"
#import "./StaffTrainingCourseSummaryFields.graphql"

query GetMyTraining {
  myTraining {
    inScope
    overall
    nextModuleSlug
    modules {
      ...StaffTrainingModuleSummaryFields
    }
    policies {
      ...StaffTrainingPolicyFields
    }
    courses {
      ...StaffTrainingCourseSummaryFields
    }
  }
}
